import {
  Dialog,
  DialogContent,
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { AgendaPreview } from "./AgendaPreview";
import { Button } from "@repo/ui/components/Base/Button";
import type { LetterHead, Meeting } from "@repo/types";
import { useTenantStore } from "@/stores/tenantStore";
import { AGENDA_MOTIF } from "@/lib/constants";
import { useGetTeam } from "@/hooks/queryHooks/teamHooks";

export const PreviewAgendaTemplateDialog = ({
  open,
  setOpen,
  meeting,
  letterHead,
}: {
  open: boolean;
  setOpen: (arg1: boolean) => void;
  meeting: Meeting;
  letterHead?: LetterHead;
}) => {
  const tenant = useTenantStore((s) => s.tenant);
  const { data: team, loaded } = useGetTeam(
    tenant?.id ?? "",
    meeting.teamId ?? ""
  );

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader className={AGENDA_MOTIF}>
          <DialogTitle>Preview Agenda</DialogTitle>
        </DialogHeader>
        <DialogBody className="h-[75vh]">
          {loaded && (
            <AgendaPreview
              tenant={tenant}
              meeting={meeting}
              team={team ?? undefined}
              letterHead={letterHead}
            />
          )}
        </DialogBody>
        <DialogFooter>
          <Button onClick={() => setOpen(false)} variant="tertiary">
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
